module.exports = {
  baseUrl: "https://zygtlvw80f.execute-api.us-east-2.amazonaws.com/test",
  systemName: 'System dev',
}

//